import { useEffect } from 'react';
import { addWindowEventListener, removeWindowEventListener } from '../models/windowData';

/**
 * Hook che effettua la registrazione e deregistrazione ad un evento window.
 * @param {string} type tipo evento
 * @param {func} listener callback
 * @param {object} options opzioni di registrazione
 * @param {string=} eventContext contesto di utilizzo dell'evento
 */
const useEventListener = (type, listener, options, eventContext = '') => {
  useEffect(() => {
    addWindowEventListener(type, listener, options, eventContext);
    return () => {
      removeWindowEventListener(type, listener, options, eventContext);
    };
  }, [listener, options, type, eventContext]);
};

export default useEventListener;
